export default __webpack_public_path__ + "static/logo-03b15a978efebbb4ba4a6834a2d06ffe.png";